jQuery_T4NT(document).ready(function($) {
  

  

  /*
    $("button.single_add_to_cart_button").click(function() {
    console.log("ManoJ - We are live!");
    dataLayer.push({'event': 'addToCart'});
  });
  */

  
});